import { ApplicationResourcesApi } from 'src/app/services/application-resources/api/application-resources.api';
import { ApplicationResource } from 'src/app/services/application-resources/models/application-resource';
import { Injectable } from '@angular/core';
import { Observable, of, firstValueFrom } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({ providedIn: 'root' })
export class ApplicationResourcesService {
  applicationResources: ApplicationResource<any>[] = [];

  constructor(private applicationResourcesApi: ApplicationResourcesApi, authService : AuthService) {}

  public initialize(): Observable<any> {
    return this.applicationResourcesApi.getAll().pipe(
      tap((resources) => {
        this.applicationResources = resources;
      }),
      catchError((err) => of(`Problem with getting resources: ${err}`))
    );
  }

  public add(resource: ApplicationResource<any>): Observable<void> {
    return this.refreshResources(this.applicationResourcesApi.create(resource));
  }

  public edit(resource: ApplicationResource<any>): Observable<void> {
    return this.refreshResources(this.applicationResourcesApi.update(resource));
  }

  public delete(resourceId: string): Observable<void> {
    return this.refreshResources(
      this.applicationResourcesApi.delete(resourceId)
    );
  }

  public get(resourceId: string) {
    return this.applicationResources.find(({ id }) => id === resourceId); // todo this should make an api call to backend
  }

  private refreshResources(action: Observable<any>): Observable<any> {
    return action.pipe(tap(async () => await firstValueFrom(this.initialize(), { defaultValue: undefined })));
  }
}
